export default __webpack_public_path__ + "static/media/goldBag.6d316126.mp3";